<template>
    <LayoutSub :parent="this.$route.path?.split('/')[2]" className="pb-0 easy_talk">
        <SubpageTitleContainer
            :title="`이지톡페이 (EasyTalkPay)`"
            subText="오프라인 신용카드 가맹점이 고객에게 청구서를 “카카오 알림톡”으로 전송하여 가맹점 방문 없이 신용카드로 결제하는 서비스입니다."
        >
            <RedLineButton :type="`inbound`" :text="`바로가기`" href="https://www.easytalkpay.co.kr/" />
        </SubpageTitleContainer>
        <SubSection class="pt-0">
            <RedTitleRow title="장점 : 가맹점">
                <li>
                    <span class="list_num">01</span>
                    기존의 가맹점 번호를 사용하여 가맹점 수수료율 변동이 없습니다.
                </li>
                <li>
                    <span class="list_num">02</span>
                    PG 가맹을 위한 비용이 필요하지 않습니다.
                </li>
                <li>
                    <span class="list_num">03</span>
                    카드사 수기(Key-In) 특약이 필요하지 않습니다.
                </li>
            </RedTitleRow>
            <RedTitleRow title="장점 : 고객">
                <li>
                    <span class="list_num">01</span>
                    가맹점을 방문하지 않아도 언제 어디서나 결제가 가능합니다.
                </li>
                <li>
                    <span class="list_num">02</span>
                    기존의 앱카드로 결제하므로 별도 회원가입이 필요하지 않습니다.
                </li>
                <li>
                    <span class="list_num">03</span>
                    결제 시, 본인인증을 진행하므로 결제 사고 위험이 없습니다.
                </li>
            </RedTitleRow>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">활용 사례</SubTitle3>
            <div class="grid-2">
                <div class="line_box">
                    <div class="line_box_header">
                        <div class="header-title-area">[학원] 납부일마다 학부모가 직접 방문하지 않아도 됩니다</div>
                    </div>
                    <div class="line-box-body">
                        <div class="content">
                            <ul class="line_box_list">
                                <li>
                                    <span class="num"
                                        >01
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">청구서 발송</div>
                                </li>
                                <li>
                                    <span class="num"
                                        >02
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">카카오 알림톡 <br />청구서 확인 및 결제</div>
                                </li>
                                <li>
                                    <span class="num">03</span>
                                    <div class="text">납부 확인</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="line_box">
                    <div class="line_box_header">
                        <div class="header-title-area">[카센터] 수리 견적을 곧바로 청구할 수 있습니다</div>
                    </div>
                    <div class="line-box-body">
                        <div class="content">
                            <ul class="line_box_list">
                                <li>
                                    <span class="num"
                                        >01
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">수리 견적 산출<br />청구서 발송</div>
                                </li>
                                <li>
                                    <span class="num">
                                        02
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">카카오 알림톡 <br />청구서 확인 및 결제</div>
                                </li>
                                <li>
                                    <span class="num">03</span>
                                    <div class="text">납부 확인<br />수리 작업 착수</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-2">
                <div class="line_box">
                    <div class="line_box_header">
                        <div class="header-title-area">[세탁소] 고객과 언제 어디서나 비대면 결제가 가능합니다</div>
                    </div>
                    <div class="line-box-body">
                        <div class="content">
                            <ul class="line_box_list">
                                <li>
                                    <span class="num"
                                        >01
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">세탁물 수령<br />청구서 발송</div>
                                </li>
                                <li>
                                    <span class="num"
                                        >02
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">카카오 알림톡 <br />청구서 확인 및 결제</div>
                                </li>
                                <li>
                                    <span class="num">03</span>
                                    <div class="text">납부 확인<br />세탁물 배달</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="line_box active">
                    <div class="line_box_header">
                        <div class="header-title-area">이지체크 가맹점이라면 언제든지 가입할 수 있습니다</div>
                    </div>
                    <div class="line-box-body">
                        <div class="content">
                            <ul class="line_box_list">
                                <li>
                                    <img src="@/assets/easy_icon1.png" alt="" />
                                    <div class="text">다수 고객에 청구서 일괄 발송</div>
                                </li>
                                <li>
                                    <img src="@/assets/easy_icon2.png" alt="" />
                                    <div class="text">언제 어디서나 결제 가능</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </SubSection>

        <SubSection>
            <SubTitle3 listStyle="dot">결제 방법</SubTitle3>
            <div class="pay_method_section">
                <div class="inner">
                    <div class="img_box"><img src="@/assets/easy_mockup1.png" alt="" /><p>청구서 알림톡</p></div>
                    <div class="img_box"><img src="@/assets/easy_mockup2.png" alt="" /><p>결제정보 확인</p></div>
                    <div class="img_box"><img src="@/assets/easy_mockup3.png" alt="" /><p>카드사 앱카드 결제</p></div>
                    <div class="img_box"><img src="@/assets/easy_mockup4.png" alt="" /><p>결제완료</p></div>
                </div>
            </div>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">서비스 신청 안내</SubTitle3>
            <div class="grid-3">
                <CardBox3 idx="1" title="사용 신청" content="관리대리점에 이지톡페이 서비스를 신청할 수 있습니다." />
                <CardBox3
                    idx="2"
                    title="서비스 가입"
                    content='가맹점 매출 관리 사이트 "이지샵 매출관리" 회원 가입 후 이지톡페이 서비스에 가입할 수 있습니다.'
                >
                    <OrangeLineButton
                        text="이지샵 가입하기"
                        href="https://www.easyshop.co.kr/taxMebs/taxMebsMbership.kicc?_method=embeddedNameCheckForm"
                    />
                </CardBox3>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import CardBox3 from '@/components/CardBox3.vue';
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import RedTitleRow from '@/components/RedTitleRow.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        RedTitleRow,
        CardBox3,
        RedLineButton,
        OrangeLineButton,
    },
};
</script>
<style lang="scss" scoped></style>
